import { useNavigate } from 'react-router-dom';
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { PDF_EXPORT_CLOSE_DROPDOWNS_EVENT } from '../helpers/downloadPageAsPDF';
import { getUserEmail, clearInternalToken, getUserRole, getRedirectURL } from '../utils/tokenUtils';

type UserMenuProps = {
  lastSyncedDate?: string;
};

const UserMenu: React.FC<UserMenuProps> = ({ lastSyncedDate }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const logoutButtonRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const userEmail = getUserEmail();
  const rawUserRole = getUserRole();
  let userRole: string | null = null;

  if (rawUserRole) {
    if (rawUserRole.includes('ROLE_COMPANY')) {
      userRole = 'Admin';
    } else if (rawUserRole.includes("ROLE_MANAGER")) {
      userRole = 'Manager';
    } else if(rawUserRole.includes("ROLE_SUPER")) {
      userRole = 'Super';
    } else {
      userRole = '';
    }
  }
  
  // Get first letter of email for display
  const getInitials = (email: string | null) => {
    if (!email) return 'U';
    return email.charAt(0).toUpperCase();
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    const closeMenu = () => setIsOpen(false);

    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener(PDF_EXPORT_CLOSE_DROPDOWNS_EVENT, closeMenu);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener(PDF_EXPORT_CLOSE_DROPDOWNS_EVENT, closeMenu);
    };
  }, []);

  const handleLogout = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    
    const redirectURL = getRedirectURL();

    
    if (redirectURL && redirectURL.trim() && redirectURL !== 'null' && redirectURL !== 'undefined') {
      const url = redirectURL.trim();
      
      try {
        window.location.replace(url);
      } catch (error) {
        window.location.href = url;
      }
    } else {
      window.location.reload();
    }
    clearInternalToken();
  }, []);

  const handleSettings = () => {
    navigate('/settings');
    setIsOpen(false);
  };

  return (
    <div className="user-menu-container">
      <div className="user-menu" ref={menuRef}>
        <div 
          className="user-avatar" 
          onClick={() => setIsOpen(!isOpen)}
          onMouseEnter={() => setIsOpen(true)}
        >
          {getInitials(userEmail)}
        </div>

        {isOpen && (
          <div className="user-dropdown">
            <div className="dropdown-header">
              <div className="user-email-display">
                {userEmail || 'User'} 
                {userRole && <span style={{ fontSize: '11px', color: '#666', paddingBottom: '4px', marginLeft: '4px' }}>- {userRole}</span>}
              </div>
              {lastSyncedDate && (
                <div className="last-update-display">
                  Updated at: {lastSyncedDate}
                </div>
              )}
            </div>
            <div className="dropdown-divider"></div>
            {/*<div className="dropdown-item" onClick={handleSettings}>
              Settings
            </div>*/}
            <div 
              ref={logoutButtonRef}
              className="dropdown-item logout" 
              onClick={handleLogout}
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              Logout
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserMenu;
